import { createAction, props } from '@ngrx/store';

export const loadClientProfiles = createAction(
  '[Client] Load Client Profile',
  props<{ forceRefresh?: boolean }>()
);
export const loadClientProfilesSuccess = createAction(
  '[Client] Load Client Profile Success',
  props<{ clients: any[] }>()
);
export const loadClientProfilesFailure = createAction(
  '[Client] Load Client Profile Failure',
  props<{ error: string }>()
);

export const loadDietPlans = createAction('[Diet] Load Diet Plans');
export const loadDietPlansSuccess = createAction(
  '[Diet] Load Diet Plans Success',
  props<{ plans: any[] }>()
);
export const loadDietPlansFailure = createAction(
  '[Diet] Load Diet Plans Failure',
  props<{ error: string }>()
);

export const selectClientProfile = createAction(
  '[Diet] Select Client Profilegh',
  props<{ id: string }>()
);
